// Lovable collection page — cover scrim, filter drawer, facets, sort.
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Cover scrim ---------------- */
  (function cover() {
    var section = document.querySelector('[data-lv-collection-cover]');
    if (!section) return;
    var scrim = section.querySelector('[data-lv-collection-cover-scrim]');
    var frame = 0;

    function update() {
      frame = 0;
      if (scrim) {
        scrim.style.opacity = Math.min(1, 0.72 + window.scrollY / 900);
      }
    }
    function onScroll() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  })();

  /* ---------------- Filter drawer ---------------- */
  (function filterDrawer() {
    var drawer = document.querySelector('[data-lv-filter-drawer]');
    var openBtn = document.querySelector('[data-lv-filter-open]');
    if (!drawer || !openBtn) return;

    var closeBtns = drawer.querySelectorAll('[data-lv-filter-close]');
    var panel = drawer.querySelector('[data-lv-filter-panel]');
    var priorOverflow = '';
    var priorFocus = null;

    function open() {
      priorFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      openBtn.setAttribute('aria-expanded', 'true');
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      if (panel) panel.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = priorOverflow;
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        drawer.hidden = true;
      }, reduceMotion ? 0 : 300);
      if (priorFocus) priorFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
  })();

  /* ---------------- Facet accordions (default open) ---------------- */
  document.querySelectorAll('[data-lv-facet]').forEach(function (facet) {
    facet.classList.add('is-open');
    var trigger = facet.querySelector('[data-lv-facet-toggle]');
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', 'true');
    trigger.addEventListener('click', function () {
      var open = facet.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------------- Clear drawer draft (no submit) ---------------- */
  document.querySelectorAll('[data-lv-filter-clear]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('[data-lv-filter-drawer]');
      if (!drawer) return;
      drawer.querySelectorAll('[data-lv-facet-input]').forEach(function (input) {
        input.checked = false;
      });
      drawer.querySelectorAll('.lv-filter-drawer__number').forEach(function (input) {
        input.value = '';
      });
    });
  });

  /* ---------------- Sort submits immediately ---------------- */
  document.querySelectorAll('[data-lv-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form') || document.querySelector('[data-lv-collection-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
})();
